export default __webpack_public_path__ + "images/pattern-1.382f551ab6a72d49e2110333de4c9508.svg";